import { Theme } from '@mui/material'

const classes = {
  modalPaperStyle: (theme: Theme) => ({
    backgroundColor: theme.palette.ui.surfaceVariant,
  }),
}

export default classes
